import { Injectable } from '@angular/core';

import { InternalEntity } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { InternalEntityPresenterModel } from '@osos/shared/types';
import { InternalEntityParserService } from '../../parsers/internal-entity-parser/internal-entity-parser.service';

@Injectable()
export class InternalEntityFactoryService extends FactoryBase<
  InternalEntity,
  InternalEntityPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: InternalEntityParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: InternalEntityPresenterModel): InternalEntity {
    const parser = this.getParser(
      InternalEntity,
      InternalEntityPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: InternalEntity): InternalEntityPresenterModel {
    const parser = this.getParser(
      InternalEntity,
      InternalEntityPresenterModel,
      1, //@TODO use model.specificationVersion
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
